export default "__VITE_ASSET__59fbf099__"